Em.Handlebars.helper 'distance', (distance) ->
  return "#{parseInt(distance)} м" if distance < 1000
  return "#{parseInt(distance/100)/10} км"
